export default __webpack_public_path__ + "static/media/Filter 1.56ae0d84.svg";